/** Default conversations list width in pixels. */
export const CONVERSATIONS_PANEL_DEFAULT_WIDTH = 260;
/** Smallest conversations list width in pixels. */
export const CONVERSATIONS_PANEL_MIN_WIDTH = 260;
/** Largest conversations list width in pixels. */
export const CONVERSATIONS_PANEL_MAX_WIDTH = 400;
